import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { FIND_MY_ACCOUNT_URL, makePath, PATH, PWA_SESSION_KEY, Span, } from 'shared';
import hamburgerIcon from 'images/utility-icons/hamburger.svg';
import { readPwaSession } from 'utils';
import { clearAccountLookupData } from '../slice';
import { clearFmaSession } from '../utils';
import Sidebar from './Sidebar';
const logo = '/Alphaeon_Patient_Financing_Logo_SVG.svg';
function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const { verificationToken } = useSelector((state) => state.root.creditPortal.findMyAccount);
    const isInFindMyAccount = location.pathname.includes(PATH.FIND_MY_ACCOUNT);
    const isAuthenticated = !!verificationToken;
    const showHamburger = isInFindMyAccount && isAuthenticated;
    const handleLogoClick = (event) => {
        clearFmaSession();
        const pwaSession = readPwaSession();
        sessionStorage.removeItem(PWA_SESSION_KEY);
        dispatch(clearAccountLookupData());
        if (pwaSession) {
            event.preventDefault();
            history.push(makePath(PATH.CREDIT_PORTAL, PATH.PAY_WITH_ALPHAEON));
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "header", children: [showHamburger && (_jsx("button", { onClick: () => setIsMenuOpen(true), className: "header__hamburger-button", "aria-label": "Open menu", children: _jsx("img", { src: hamburgerIcon, alt: "Menu" }) })), _jsx(Link, { to: FIND_MY_ACCOUNT_URL, onClick: handleLogoClick, children: _jsx("img", { src: logo, className: "logo", alt: "Logo", width: 224, height: 59 }) }), _jsxs("div", { className: "wizard-header-title", children: [_jsx(LockOutlinedIcon, {}), _jsx(Span, { variant: "title-medium", bold: true, children: "Secure Application" })] })] }), showHamburger && isMenuOpen && (_jsx(Sidebar, { isOpen: isMenuOpen, onClose: () => setIsMenuOpen(false) }))] }));
}
export default memo(Header);
